import React from "react";
import Modal from "../../../../components/modal";
import {CancelButton, FlexContainer, SubmitButton, Text} from "../../../../design";


const CancelConfirmationModal = (props) => {
  const { open, close, confirmCancel } = props;
  return (
    <Modal isOpen={open}>
        <FlexContainer
            height="300px"
            display="flex"
            alignItems="center"
            justifyContent="center"
            flexDirection="column"
            box-shadow="0 0 20px 0 rgba(0, 0, 0, 0.1)"
            backdropFilter='none'
            borderRadius='4px'
            backgroundColor="#f2f5f8"
            textAlign='center'
            alignContent='none'
        >
            <Text fontSize="16px" textAlign="center" paddingX="14px" fontWeight='800'>
              Are you sure you want to cancel the subscription?
            </Text>
            <FlexContainer
              justifyContent="center"
              alignItems="center"
              width="100%"
            >
              <CancelButton
                onClick={() => close()}
                type="button"
              >No</CancelButton>
              <SubmitButton
                onClick={() => confirmCancel()}
                type="button"
              >Yes</SubmitButton>
            </FlexContainer>
      </FlexContainer>
    </Modal>
  )
};

export default CancelConfirmationModal;
